import React from "react";
import LegalLayout, { Section } from "@/pages/legal/LegalLayout";

export default function Refunds() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" updated="June 2026" testid="refunds-page">
      <Section title="1. Plans & cancellation">
        <p>
          AutoGridSocial offers a <strong>Pro subscription at $29/month</strong> and a one-time
          <strong> $10 credit pack</strong> (3 campaigns, no subscription). You may cancel your Pro subscription at any
          time from the account's Billing page or via the Stripe customer portal. Cancellation takes effect at the end of
          the current billing period, and you keep access until then.
        </p>
      </Section>
      <Section title="2. Billing">
        <p>
          Pro is billed immediately at <strong>$29/month</strong> at checkout and renews each month until you cancel.
          There is <strong>no trial fee</strong>. The $10 credit pack is a single one-time charge that grants 3 campaign
          credits — it is not a subscription and does not renew.
        </p>
      </Section>
      <Section title="3. Refunds">
        <p>
          Fees for completed billing periods are generally non-refundable. However, we want you to be happy — if you were
          charged in error, or you cancel within <strong>7 days of a charge</strong> and have not made substantial use of
          the service, contact us and we will review your request for a full or prorated refund in good faith. Unused
          credit-pack credits may be refunded on request within 14 days of purchase if no campaign has been generated.
        </p>
      </Section>
      <Section title="4. How to cancel">
        <ul className="list-disc pl-5 space-y-1">
          <li>Go to <strong>Billing</strong> in your dashboard and open <strong>Manage / cancel plan</strong>, or</li>
          <li>Use the <strong>Stripe customer portal</strong> link provided there to cancel or switch plans.</li>
        </ul>
      </Section>
      <Section title="5. Contact for assistance">
        <p>
          Need help with a cancellation or refund? Email{" "}
          <a href="mailto:beckettseb367@gmail.com" className="underline hover:text-foreground">beckettseb367@gmail.com</a>{" "}
          and we'll respond as quickly as possible.
        </p>
      </Section>
    </LegalLayout>
  );
}
